import * as React from 'react';
import { useContext } from 'react';

import type {
  DdpFieldsAboveFold2Fragment,
  DdpFieldsAboveFoldFragment,
  DdpFieldsBelowFoldFragment,
  DdpFieldsProgramDetailsFragment,
} from 'bundles/degree-description/__generated__/contentfulTypes';
import type { AverageCourseStarRating } from 'bundles/degree-description/types';
import type { RetrieveCompletedSurveyResponse } from 'bundles/expression-of-interest/queries/RetrieveCompletedQualificationSurvey';
import type { AvailabilityStatus } from 'bundles/premium-hub/types';

export type MergedDegreeDescriptionPageFields = DdpFieldsAboveFoldFragment &
  DdpFieldsAboveFold2Fragment &
  DdpFieldsBelowFoldFragment &
  DdpFieldsProgramDetailsFragment;

export type DegreeDescriptionPageContextType = {
  id: string;
  productVariant?: string;
  loading: boolean;
  degreeAvailabilityStatus: AvailabilityStatus;
  blockedCountries: string[];
  pageContent?: MergedDegreeDescriptionPageFields | null;
  averageCourseStarRating?: AverageCourseStarRating;
  eoiSurveyData?: RetrieveCompletedSurveyResponse;
  loadingEoiSurveyData: boolean;
  isEoiSurveyLoading: boolean;
  experimentValues: {
    redesign2026Variant: string | undefined;
    eoiVariant: string | undefined;
  };
};

export const DegreeDescriptionPageContext = React.createContext<DegreeDescriptionPageContextType | undefined>(
  undefined
);

export const useDegreeDescriptionPageData = () => {
  const context = useContext(DegreeDescriptionPageContext);
  if (!context) throw new Error('useDegreeDescriptionPageData was used outside of DegreeDescriptionPageContext');
  return context;
};

export const EOI_VARIANT_REDESIGN_2026 = 'redesign-2026-ddp';

export const useIsEoiRedesign2026 = () =>
  useDegreeDescriptionPageData().experimentValues.eoiVariant === EOI_VARIANT_REDESIGN_2026;

export default DegreeDescriptionPageContext;
